module.exports = __webpack_public_path__ + "img/pro-m-slider25.8c286966.jpg";